import * as React from 'react';
import { cn } from '../lib/utils.js';

// ─── Types ────────────────────────────────────────────────────

export interface PageToolbarProps {
  /** Content anchored to the left side of the toolbar (secondary actions). */
  leftSlot?: React.ReactNode;
  /** Content anchored to the right side of the toolbar (primary + secondary CTAs). */
  rightSlot?: React.ReactNode;
  /**
   * Optional footer row rendered below the main action row, right-aligned.
   * Useful for contextual hints (e.g. "Skipping N rows with errors").
   */
  footer?: React.ReactNode;
  className?: string;
}

// ─── Component ───────────────────────────────────────────────

export function PageToolbar({ leftSlot, rightSlot, footer, className }: PageToolbarProps) {
  return (
    <div
      className={cn(
        'shrink-0 border-t border-border bg-background px-6 py-3 flex flex-col gap-1',
        className,
      )}
      data-testid="page-toolbar"
    >
      <div className="flex items-center justify-between gap-3">
        {leftSlot != null ? (
          <div className="flex items-center gap-2 shrink-0">{leftSlot}</div>
        ) : (
          <div />
        )}
        {rightSlot != null ? (
          <div className="flex items-center gap-3 shrink-0">{rightSlot}</div>
        ) : null}
      </div>
      {footer != null ? <div className="flex justify-end">{footer}</div> : null}
    </div>
  );
}
